import { Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { Chip } from 'components/chips'
import { LabelField } from 'components'
import { VehicleDamageDto } from 'dtos'
import moment from 'moment'
import { formatDate } from 'utils'

interface DamageHeroCardProps {
  damage: VehicleDamageDto
}

export default function DamageHeroCard({ children, damage }: React.PropsWithChildren<DamageHeroCardProps>) {
  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} alignItems='flex-start'>
          <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
            <Grid item xs={12} sm={true} container alignItems='center' spacing={0}>
              <Grid item>
                <Typography fontWeight='bold' variant='h5' sx={{ pr: 1 }}>
                  {damage.vin}
                </Typography>
              </Grid>

              {damage.damageStatus === 'Resolved' && (
                <Grid item>
                  <Chip variant='green'>Resolved</Chip>
                </Grid>
              )}

              {damage.damageStatus === 'Unresolved' && (
                <Grid item>
                  <Chip variant='red'>Unresolved</Chip>
                </Grid>
              )}
            </Grid>

            <Grid item xs={12} sm='auto' container alignItems='center' spacing={1}>
              {children}
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12} sm={3}>
            <LabelField label='Initial Damage Date' value={moment(damage.createdDateTime).format('M/D/yyyy')} />
          </Grid>

          <Grid item xs={12} sm={3}>
            <LabelField label='Updated' value={formatDate(damage.updatedDateTime)} />
          </Grid>

          <Grid item xs={12} sm={3}>
            <LabelField label='Exporter' value={damage.exporterCompany?.name} />
          </Grid>

          <Grid item xs={12} sm={3}>
            <LabelField label='Buyer' value={damage.buyerCompany?.name} />
          </Grid>

          <Grid item xs={12} sm={3}>
            <LabelField label='Importer Stock #' value={damage.importerStockNumber} />
          </Grid>

          <Grid item xs={12} sm={3}>
            <LabelField label='Year' value={damage.year} />
          </Grid>

          <Grid item xs={12} sm={3}>
            <LabelField label='Make' value={damage.make} />
          </Grid>

          <Grid item xs={12} sm={3}>
            <LabelField label='Model' value={damage.model} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
